import { useFetchMxfNestApi } from "../../hooks/useMxfApiNest";
import { getURLWithParams } from "utils/context";

export const useLogList = (params = {}) =>
  useFetchMxfNestApi(getURLWithParams("/logs", params));
